import type { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';
import { useSuspenseInfiniteQuery } from '@tanstack/react-query';
import { formatInTimeZone } from 'date-fns-tz';
import { getRedditPostsOptions } from '../api';
import { PAGE_SIZE } from '../constants';
import useTrendsQueryParams from '../hooks/useTrendsQueryParams';
import { getDateRangeFromTimeRange } from '../utils';

const TrendsTimestamp: FC = () => {
  const { timeRange, keywordIds, postType, sortBy } = useTrendsQueryParams();
  const { date_from, date_to } = getDateRangeFromTimeRange(timeRange);

  const {
    data: { loadTs },
  } = useSuspenseInfiniteQuery(
    getRedditPostsOptions({
      date_from,
      date_to,
      keyword_id: keywordIds.length > 0 ? keywordIds : undefined,
      post_type: postType === 'all' ? undefined : postType,
      order_by: sortBy,
      desc: true,
      limit: PAGE_SIZE,
    })
  );

  if (!loadTs) return null;

  const formatted = formatInTimeZone(new Date(loadTs), 'UTC', "MMM d, yyyy HH:mm '(UTC+0)'");

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
      <InfoOutlinedIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
      <Typography variant="caption" color="text.secondary" noWrap>
        Last data synchronization happened on: {formatted}
      </Typography>
    </Box>
  );
};

export default TrendsTimestamp;
